module.exports = __webpack_public_path__ + "img/currentHelmet.02dc1b32.png";